import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import { COLOR } from 'constants/colors';
import Checkbox from '__utils/customisedCheckBox';
import { mixpanelTrack } from './verify-mandate';
import UserMandateSelector from '../mandate.selector';
import CustomRadio from 'components/custom-radio';

interface EmandateProps {
    selectedPaymentTypeInput: string;
    onDeclCheck: Function;
}

const EMandate: React.FC<EmandateProps> = ({ selectedPaymentTypeInput, onDeclCheck }: EmandateProps) => {

    const { register } = useForm({ mode: 'onChange' });
    const { mandateActivateConfig } = propsToJS(useSelector(UserMandateSelector));
    const [selectedPaymentType, setSelectedPaymentType] = useState<string>('');
    const [declared, setDeclared] = useState<boolean>(false);

    useEffect(() => {
        selectedPaymentTypeInput && setSelectedPaymentType(selectedPaymentTypeInput);
    }, [selectedPaymentTypeInput])

    const onRadioCheck = (eventName: string, value: string) => {
        mixpanelTrack(eventName, 'clicked');
        setSelectedPaymentType(value);
    }

    return (
        <div>
            <p className='questionFont'>Verify using</p>
            <div className='flex-col'>

                {mandateActivateConfig?.debitCardAllowed && <CustomRadio
                    label='ATM - Debit Card'
                    value="Debit"
                    name="selectedPaymentType"
                    checked={selectedPaymentType === 'Debit'}
                    onChange={() => onRadioCheck('debitClick', 'Debit')}
                    radiobuttonRef={register()}
                />}

                {mandateActivateConfig?.netBankingAllowed && <CustomRadio
                    label='Net Banking'
                    value="Net"
                    name="selectedPaymentType"
                    checked={selectedPaymentType === 'Net'}
                    onChange={() => onRadioCheck('netBankingClick', 'Net')}
                    radiobuttonRef={register()}
                />}

            </div>
            <br />

            <label>
                <Checkbox
                    name="declChecked"
                    label={<span style={{ color: COLOR.GREY }} >I hereby authorize BSE Limited to debit from my bank account as per this mandate. </span>}
                    checked={declared}
                    onChange={(e: any) => {
                        setDeclared(e.target.checked);
                        onDeclCheck(e.target.checked)
                    }}
                    checkboxRef={register}
                />
            </label>



        </div>
    )
}

export default EMandate